import { SearchOutlined } from '@ant-design/icons'
import { Col, Input, Row } from 'antd'
import React, { useContext, useEffect } from 'react'

import LoadingButton from 'src/components/styled/LoadingButton'
import { useWindowWidth } from 'src/utils/useWindowWidth'
import styled, { ThemeContext } from 'styled-components/macro'
import { setTitle, setError } from 'src/features/CustomerSearchSlice'
import { useDispatch, useSelector } from 'react-redux'
const SearchCustomer = ({ resultCount = 0 }) => {
  const dispatch = useDispatch()
  const searchTitle = useSelector(state => state.customerSearch.title)
  const searchError = useSelector(state => state.customerSearch.error)

  useEffect(() => {
    dispatch(setError(''))
  }, [])

  const onSearch = () => {
    // Client-side filtering is handled in parent component
    // Just clear error if search term is empty
    if (!searchTitle.trim()) {
      dispatch(setError('Please enter a search term'))
      dispatch(setTitle(''))
    } else {
      dispatch(setError(''))
    }
  }

  const windowWidth = useWindowWidth()
  const theme = useContext(ThemeContext)
  const isMobile = windowWidth <= theme.breakpoints.lg
  return (
    <Input.Group size='large' style={{ width: '100%', marginBottom: 20 }}>
      <Row gutter={16}>
        <Col span={isMobile ? 24 : 8}>
          <Input
            prefix={<SearchOutlined />}
            placeholder='Search by...'
            value={searchTitle}
            onChange={e => {
              dispatch(setError(''))
              dispatch(setTitle(e.target.value))
            }}
            onPressEnter={onSearch}
            allowClear
          />
          {searchError && <SearchError>{searchError}</SearchError>}
        </Col>

        <Col span={isMobile ? 12 : 2}>
          <LoadingButton type='primary' size='large' onClick={onSearch}>
            Search
          </LoadingButton>
        </Col>
        <Col span={isMobile ? 12 : 8}>
          {Boolean(searchTitle.trim()) && (
            <SearchResultCount>
              {resultCount} {resultCount === 1 ? 'result' : 'results'}
            </SearchResultCount>
          )}
        </Col>
      </Row>
    </Input.Group>
  )
}

const SearchResultCount = styled.p`
  min-height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
`

const SearchError = styled.p`
  color: ${({ theme }) => theme.colours.chilliRed};
`

export default SearchCustomer
